import React, { useState, useEffect } from "react";
import "./landing-page.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectUserLanguage, setLanguage } from "../../features/user/userSlice";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import HambMenu from "../../components/hamburger-menu/HambMenu";
import useLanguage from "../../hooks/useLanguage";
import imageLanding from "../../assets/images/imageMainLanding.png";
import separacionLanding from "../../assets/images/separacion-landing.png";
import xignux from "../../assets/images/xignux.png";
import heineken from "../../assets/images/heineken.png";
import ford from "../../assets/images/ford.png";
import hackaton from "../../assets/images/hackaton.png";
import mobilityHackaton from "../../assets/images/mobilityHackaton.png";
import presentacionHackaton from "../../assets/images/presentacionHackaton.png";
import gubernamental from "../../assets/images/recompensaGubernamental.png";
import empleados from "../../assets/images/recompensaEmpleados.png";
import puntualidad from "../../assets/images/puntualidad.png";
import bienestar from "../../assets/images/bienestar.png";
import ambiental from "../../assets/images/ambientalLanding.png";
import screenOne from "../../assets/images/screenOne.png";
import screenTwo from "../../assets/images/screenTwo.png";
import screenThree from "../../assets/images/screenThree.png";
import phoneAMVI from "../../assets/images/phoneAMVI.png";
import screensMobile from "../../assets/images/app-mobile.png";
import videoEmpresas from "../../assets/video/videoLanding.mp4";
import useWindowWidth from "../../hooks/useWindowWidth";

const LandingPage = () => {
  const windowWidth = useWindowWidth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentLanguage = useSelector(selectUserLanguage) || "es";

  // Get texts based on current language
  const texts = useLanguage(currentLanguage, "views.landingPage");

  // Initialize language if not set
  useEffect(() => {
    if (!currentLanguage) {
      dispatch(setLanguage("es"));
    }
  }, [currentLanguage, dispatch]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleRedirect = (url) => {
    window.open(url, "_blank", "noopener,noreferrer"); // Redirección a URL externa
  };

  const [showMenu, setShowMenu] = useState(false);

  return (
    <>
      <Header texts={texts} showMenu={showMenu} setShowMenu={setShowMenu} />
      {!showMenu ? (
        <main className="body-landing">
          <div className="main-landing" id="main">
            <div className="text-main-landing">
              <h2>{texts.main.title}</h2>
              <p>{texts.main.subtitle}</p>
              <button>{texts.main.learnMore}</button>
            </div>
            <img src={imageLanding} alt="main" />
          </div>
          <div className="helper-container">
            <p>{texts.support.title}</p>
            <div>
              <img src={xignux} alt="xignux" />
              <img src={heineken} alt="heineken" />
              <img src={ford} alt="ford" />
            </div>
          </div>
          <div className="banner-container">
            <img src={separacionLanding} alt="banner" />
          </div>
          <div className="hackaton-container">
            <h2>{texts.hackathon.title}</h2>
            <div className="hackaton-description-container">
              <div className="left-description-container">
                <div className="hackathon-description-paragraph">
                  <p>{texts.hackathon.description1}</p>
                  <br />
                  <p>{texts.hackathon.description2}</p>
                </div>
                <img
                  src={hackaton}
                  alt="hackathon"
                  className="image-hackaton"
                />
                <div className="hackathon-date-and-time-container">
                  <div className="event-day-container">
                    <img src={mobilityHackaton} alt="" />
                    <div className="event-day-date-container">
                      <label>{texts.hackathon.hackathonTitle}</label>
                      <p>{texts.hackathon.hackathonDate}</p>
                      <p>{texts.hackathon.hackathonDescription}</p>
                      <span>{texts.hackathon.hackathonLocation}</span>
                      <span
                        onClick={() => handleRedirect("https://lu.ma/rdkmgx4p")}
                      >
                        {texts.hackathon.hackathonRegister}
                      </span>
                    </div>
                  </div>
                  <div className="event-day-container">
                    <img src={presentacionHackaton} alt="" />
                    <div className="event-day-date-container">
                      <label className="second-title">
                        {texts.hackathon.presentationTitle}
                      </label>
                      <p>{texts.hackathon.presentationDate}</p>
                      <p>{texts.hackathon.presentationDescription}</p>
                      <span>{texts.hackathon.presentationLocation}</span>
                      <span
                        onClick={() => handleRedirect("https://lu.ma/jtyplgos")}
                      >
                        {texts.hackathon.presentationRegister}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <img src={hackaton} alt="hackathon" />
            </div>
          </div>
          <div className="banner-container">
            <img src={separacionLanding} alt="banner" />
          </div>
          <div className="functionality-container">
            <label>{texts.functionality.title}</label>
            <p>{texts.functionality.description}</p>
            <video width={windowWidth > 480 ? "600" : "350"} controls>
              <source src={videoEmpresas} type="video/mp4" />
            </video>
          </div>
          <div className="corporate-benefits" id="beneficios">
            <label>
              {texts.benefits.title} <span>{texts.benefits.companies}</span>
            </label>
            <p>{texts.benefits.description}</p>
            <div className="benefits-container">
              <div>
                <img src={puntualidad} alt="puntualidad" />
                <label>{texts.benefits.punctuality.title}</label>
                <p>{texts.benefits.punctuality.description}</p>
              </div>
              <div>
                <img src={bienestar} alt="bienestar" />
                <label>{texts.benefits.wellbeing.title}</label>
                <p>{texts.benefits.wellbeing.description}</p>
              </div>
              <div>
                <img src={ambiental} alt="ambiental" />
                <label>{texts.benefits.environmental.title}</label>
                <p>{texts.benefits.environmental.description}</p>
              </div>
            </div>
          </div>
          <div className="incentives-container" id="incentivos">
            <label>{texts.incentives.title}</label>
            <p>{texts.incentives.description}</p>
            <div className="incentives-list">
              <div className="incentive-item">
                <img
                  src={gubernamental}
                  alt="government-incentive"
                  className="incentive-image--gubernamental"
                />
                <label className="incentive-subtitle gubernamental">
                  {texts.incentives.government.title}
                </label>
                <p>{texts.incentives.government.description}</p>
              </div>
              <div className="incentive-item">
                <img
                  src={empleados}
                  alt="employee-incentive"
                  className="incentive-image--empleados"
                />
                <label className="incentive-subtitle empleados">
                  {texts.incentives.employees.title}
                </label>
                <p>{texts.incentives.employees.description}</p>
              </div>
            </div>
          </div>
          <div className="banner-container">
            <img src={separacionLanding} alt="banner" />
          </div>
          <div className="plans-container" id="planes">
            <div className="main-plans-container">
              <div className="our-plans-container">
                <label>{texts.plans.title}</label>
                <p>{texts.plans.description}</p>
                <br />
                <button>{texts.plans.contactUs}</button>
              </div>
              <div className="cards-container">
                <div className="card-plans-container">
                  <label>{texts.plans.essential.title}</label>
                  <p>{texts.plans.essential.description}</p>
                  <ul>
                    {texts.plans.essential.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                  <button>{texts.plans.contactUs}</button>
                </div>
                <div className="card-plans-container">
                  <label>{texts.plans.advanced.title}</label>
                  <p>{texts.plans.advanced.description}</p>
                  <ul>
                    {texts.plans.advanced.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                  <button>{texts.plans.contactUs}</button>
                </div>
              </div>
            </div>
          </div>
          <div className="app-container" id="aplicaion">
            <div className="screens-container">
              <img src={screenOne} alt="screenOne" />
              <img src={screenTwo} alt="screenTwo" />
              <img src={screenThree} alt="screenThree" />
              <img src={phoneAMVI} alt="phoneAMVI" />
            </div>
            <div className="app-information-container">
              <label>{texts.app.title}</label>
              <p>{texts.app.description}</p>
              <br />
              <img src={screensMobile} alt="app-mobile" />
              <button>{texts.app.learnMore}</button>
            </div>
          </div>
          <div className="invitation-question-container">
            <label>{texts.invitation.title}</label>
            <p>{texts.invitation.description}</p>
            <button>{texts.invitation.contactUs}</button>
          </div>
          <Footer />
        </main>
      ) : (
        <HambMenu showMenu={showMenu} setShowMenu={setShowMenu} />
      )}
    </>
  );
};

export { LandingPage };
